export default __webpack_public_path__ + "static/media/location-mockups.897d1dee.png";